import { CSSProperties, ReactElement } from 'react';

export const BodyCellComponent = ({
  style,
  ...rest
}: { style: CSSProperties }): ReactElement => (
  <td
    {...rest}
    style={{
      padding: 0,
      ...style,
    }}
  />
);
